
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/authentication",
      function () {
        return require("private-next-pages/apipages/authentication/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/authentication"])
      });
    }
  